module.exports = __webpack_public_path__ + "static/img/Plastpall-half.6f4e0e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Plastpall-half.jpg
// module id = DI8g
// module chunks = 1